import { moneyToNumber } from "@babybjorn/utils/commercetools/money";
import type { Cart, LineItem } from "@commercetools/platform-sdk";

interface BeginCheckoutEventItem {
	item_id: string;
	item_name: string;
	affiliation?: string;
	coupon?: string;
	currency: string;
	discount: number;
	index?: number;
	item_brand?: string;
	item_category?: string;
	item_category2?: string;
	item_category3?: string;
	item_category4?: string;
	item_category5?: string;
	item_list_id?: string;
	item_list_name?: string;
	item_variant: string;
	location_id?: string;
	price: number;
	quantity: number;
}

interface BeginCheckoutEventData {
	currency: string;
	value: number;
	coupon?: string;
	items: BeginCheckoutEventItem[];
}

const getLineItemData = (lineItem: LineItem): BeginCheckoutEventItem => {
	return {
		item_id: lineItem.variant.sku || "",
		item_name: lineItem.name[process.env.GATSBY_LANGUAGE || ""] || "",
		currency: lineItem.price.value.currencyCode,
		affiliation: `Babybjorn ${process.env.GATSBY_STORE}`,
		price: moneyToNumber(lineItem.price.value),
		quantity: lineItem.quantity,
		item_variant: lineItem.variant.key || "",
		discount:
			moneyToNumber(lineItem.price.value) -
			moneyToNumber(lineItem.price.discounted?.value),
	};
};

export const getData = (cart: Cart): BeginCheckoutEventData => {
	let subtotal = 0;
	for (const lineItem of cart.lineItems) {
		subtotal += moneyToNumber(lineItem.totalPrice) * lineItem.quantity;
	}

	return {
		currency: cart.totalPrice.currencyCode,
		value: subtotal,
		coupon:
			cart.discountCodes.map((code) => code.discountCode.obj?.code)[0] ||
			undefined,
		items: cart.lineItems.map(getLineItemData),
	};
};
